import { render, staticRenderFns } from "./Dash-activity.vue?vue&type=template&id=a2f406c4"
import script from "./Dash-activity.vue?vue&type=script&lang=js"
export * from "./Dash-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports